import { createSlice } from "@reduxjs/toolkit";
import { getCities, getNeighborhood, getStates, getZones } from "./thunk";

export const initialState: any = {
  states: [],
  cities: [],
  zones: [],
  neighborhood: []
};

const AddressSlice = createSlice({
  name: 'AddressSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getStates.fulfilled, (state: any, action: any) => {
      if (action.payload) {
        for (let item of action.payload) {
          const stateIndex = state.states.findIndex((x: any) => x._id === item._id);
          if (stateIndex === -1) {
            state.states.push(item);
          }
        }
      }
    })
    builder.addCase(getStates.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(getCities.fulfilled, (state: any, action: any) => {
      if (action.payload && action.payload.length) {
        for (let item of action.payload) {
          const cityIndex = state.cities.findIndex((x: any) => x._id === item._id);
          if (cityIndex === -1) {
            state.cities.push(item);
          }
        }
      }
    })
      .addCase(getCities.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

    builder.addCase(getZones.fulfilled, (state: any, action: any) => {
      if (action.payload && action.payload.length) {
        for (let item of action.payload) {
          const zoneIndex = state.zones.findIndex((x: any) => x._id === item._id);
          if (zoneIndex === -1) {
            state.zones.push(item);
          }
        }
      }
    })
      .addCase(getZones.pending, (state) => {
        state.loading = true;
        state.error = null;
      });
      builder.addCase(getNeighborhood.fulfilled, (state: any, action: any) => {
        if (action?.payload && Array.isArray(action.payload)) {
          for (let item of action.payload) {
            const neigborIndex = state.neighborhood.findIndex((x: any) => x._id === item._id);
            if (neigborIndex === -1) {
              state.neighborhood.push(item);
            }
          }
      } else {
          console.log("Payload is empty or not an array");
      }
      })
        .addCase(getNeighborhood.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
  },

}
);

export default AddressSlice.reducer;